import _ from 'lodash'
import { Map, Record } from 'immutable'

import { SET_USER_PROFILE_CONTENT_HEIGHT } from './constants'
import {
    USER_PROFILE_LOAD_CONTENT,
    USER_PROFILE_CONTENT_LOADED,
    USER_PROFILE_SHOW_LOADER,
    USER_PROFILE_HIDE_LOADER,
} from './components/Loader/constants'

export const ContentRecord = Record({
    height: 0,
    contents: Map(),
})

export default (state = new ContentRecord(), action = {}) => {
    switch (action.type) {
        case SET_USER_PROFILE_CONTENT_HEIGHT: {
            const newHeight = _.get(action, 'data.height', 0)

            return state.set('height', newHeight)
        }
        case USER_PROFILE_LOAD_CONTENT: {
            const contentId = _.get(action, 'data.id', null)

            return state.setIn(['contents', contentId, 'isLoading'], true)
        }
        case USER_PROFILE_CONTENT_LOADED: {
            const contentId = _.get(action, 'data.id', null)
            const contentData = _.get(action, 'data.contentData', Map())

            return state
                .setIn(['contents', contentId, 'isLoading'], false)
                .setIn(['contents', contentId, 'isLoaded'], true)
                .setIn(['contents', contentId, 'data'], contentData)
        }
        case USER_PROFILE_SHOW_LOADER: {
            const contentId = _.get(action, 'data.id', null)

            return state.setIn(['contents', contentId, 'showLoader'], true)
        }
        case USER_PROFILE_HIDE_LOADER: {
            const contentId = _.get(action, 'data.id', null)

            return state.setIn(['contents', contentId, 'showLoader'], false)
        }
        default:
            return state
    }
}
